import { useCallback, useEffect, useState } from "react";
import api from "screens/Root/api";
export const useSecurityRights = (menuId) => {
    const [loading, setLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);
    const mapSecurityRight = (securityRight) => {
        switch (securityRight) {
            // Default
            case 0:
            // Full
            case 1:
            // Readonly
            case 2:
            // CannotEditFinal
            case 3:
            // DraftsOnly
            case 4:
                return true;
            // Deny
            case 5:
            default:
                return false;
        }
    };
    const fetchSecurityRight = useCallback(async () => {
        setHasAccess(false);
        setLoading(true);
        const response = await api.getSecuriryRightsFromMenuId(menuId);
        setHasAccess(mapSecurityRight(response.data));
        setLoading(false);
    }, [menuId]);
    useEffect(() => {
        fetchSecurityRight();
    }, [menuId]);
    return { loading, hasAccess };
};
